import { render, staticRenderFns } from "./BtnSelect.vue?vue&type=template&id=56733d08&scoped=true&"
import script from "./BtnSelect.vue?vue&type=script&lang=js&"
export * from "./BtnSelect.vue?vue&type=script&lang=js&"
import style0 from "./BtnSelect.vue?vue&type=style&index=0&id=56733d08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56733d08",
  null
  
)

export default component.exports